/*
 * @Author: your name
 * @Date: 2021-10-18 14:29:13
 * @LastEditTime: 2021-11-09 13:02:36
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \booksnote\src\views\home\Home.js
 */
// eslint-disable-next-line no-unused-vars
import {
  getUrl,
  getContent,
  getSearch,
  submitContent,
  getverlist,
  getHistoryZWContent
} from '@/api/index'
import { UserDataChange } from '@/api/user'
import {
  GET_USER,
  REMOVE_TOKEN
} from '@/utils/auth'
import bindScroll from '@/utils/scrollspy.js'
import md5 from 'js-md5'

export default {
  data() {
    return {
      msg: '',
      disabled: false,
      userInfo: {},
      userStatus: {
        // 用户权限
        write: 0, // 用户是否可以编辑 0 只读, 1 可编辑
        translated: 0 // 0 翻译中, 1 审核中
      },
      urlList: [],
      defaultProps: {
        children: 'children',
        label: 'name',
        isLeaf: 'leaf'
      },
      zhContent: [], // 中文经文
      zwContent: '', // 藏文经文
      zjContent: [], // 经文注释
      oldContent: '',
      drawer: false, // 搜索左弹框
      direction: 'rtl', // 搜索弹框位置
      drawerHistory: false, // 修订历史弹框
      searchBtnIsShow: false,
      keyword: '',
      searchList: [], // 搜索列表
      timer: null,
      filePath: '',
      isScroll: false,
      isEdit: true,
      dialogSubmit: false, // 提交弹框
      submitForm: {
        remark: '', // 备注
        translated: '0' // 是否完成翻译
      }, // 提交编辑信息
      editHistoryList: [], // 提交历史列表
      historyNum: 0,
      subTimer: 0.1,
      historyZWContent: '', // 历史版本藏文内容
      inline: false, // 富文本编辑器展示模式 true为内联模式 false为非内联模式(iframe方式嵌入)
      editNum: 1000, // 富文本插件父盒子的key, 可以在改变内联模式后强制更新富文本组件
      passFrom: {
        password: '',
        nickname: '',
        description: ''
      },
      passChangeDialog: false
    }
  },
  computed: {
    userIsEdit() {
      const isEdit =
        this.zwContent === '' ||
        this.userInfo.groupid === 0 ||
        ~~this.userStatus.write === 0
      return isEdit
    }
  },
  watch: {
    zwContent: {
      handler(v) {
        if (v === '') {
          this.subTimer = 0.1
        }
        if (this.subTimer) {
          clearTimeout(this.subTimer)
          this.subTimer = null
        } else {
          this.subTimer = setTimeout(() => {
            this.msg = '保存中...'
            const data = {
              path: this.filePath,
              langtype: 2,
              userid: this.userInfo.userid,
              contents: this.contentToArr()
            }
            this.submitEdit(data, () => {
              window.console.log('自动保存成功')
              // clearTimeout(this.subTimer)
              // this.subTimer = null
              this.msg = '已自动保存'
              setTimeout(() => {
                const date = new Date()
                const s = date.getHours()
                const f = date.getMinutes()
                this.msg =
                  '最近保存   ' +
                  `${s > 9 ? s : '0' + s}:${
                    f > 9 ? f : '0' + f
                  }`
              }, 1800)
            })
          }, 2000)
        }
      },
      deep: true
    }
  },
  created() {
    this.userInfo = GET_USER()
    this.isEdit = !(this.userInfo.groupid === 51)
    this.getUrlList('/', true)
  },
  mounted() {
    document.addEventListener('click', () => {
      this.drawer = false
      this.searchBtnIsShow = false
    })
    this.$nextTick(() => {
      this.resizeBoxChange()
    })
    window.addEventListener(
      'resize',
      this.resizeBoxChange
    )
    if (window.$) {
      bindScroll()
    }
  },
  methods: {
    resizeBoxChange() {
      const aside = this.$refs.homeAside
      const content = this.$refs.zhongwenBox
      const resizeBox = this.$refs.resize
      const resizeBox1 = this.$refs.resize1
      const w = aside.offsetWidth
      const h = content.offsetHeight
      resizeBox.style.left = w + 16 + 'px'
      resizeBox1.style.left = w + 20 + 'px'
      resizeBox1.style.top = h + 17 + 'px'
      if (!this.isEdit) {
        resizeBox1.style.display = 'none'
      }
    },
    resize1Mousedown(e) {
      e.preventDefault()
      if (!this.isEdit) return
      // const zangwenBox = this.$refs.leftBottom
      const zhongwenBox = this.$refs.zhongwenBox
      const resizeBox1 = this.$refs.resize1
      const h = zhongwenBox.offsetHeight
      const y1 = e.clientY
      document.onmousemove = function(ev) {
        ev.preventDefault()
        const y2 = ev.clientY
        const yNum = y2 - y1

        zhongwenBox.style.height =
            h + yNum + 'px'
        // zangwenBox.style.height =
        //   h - yNum + 'px'
        resizeBox1.style.top = h + yNum + 17 + 'px'
      }
      document.onmouseup = function() {
        document.onmousemove = null
      }
    },
    resizeMousedown(e) {
      e.preventDefault()
      const content = this.$refs.homeContent
      const aside = this.$refs.homeAside
      const resizeBox = this.$refs.resize
      const resizeBox1 = this.$refs.resize1
      const w = aside.offsetWidth
      resizeBox.style.left = w + 16 + 'px'
      const x1 = e.clientX
      const oldWidth = content.offsetWidth
      document.onmousemove = function(ev) {
        ev.preventDefault()
        const x2 = ev.clientX

        const x = x2 - x1

        content.style.width = oldWidth - x + 'px'
        resizeBox.style.left = w + 16 + x + 'px'
        resizeBox1.style.left = w + x + 20 + 'px'
      }
      document.onmouseup = function() {
        document.onmousemove = null
      }
    },
    // asideMousedown(e) {
    //   const content = this.$refs.homeContent
    //   const aside = this.$refs.homeAside
    //   const w = aside.offsetWidth
    //   const asx = e.offsetX
    //   if (asx < w && asx > w - 25) {
    //     const x1 = e.clientX
    //     const oldWidth = content.offsetWidth
    //     document.onmousemove = function(ev) {
    //       ev.preventDefault()
    //       const x2 = ev.clientX

    //       const x = x2 - x1

    //       content.style.width =
    //         oldWidth - x + 'px'
    //     }
    //   }
    //   document.onmouseup = function() {
    //     document.onmousemove = null
    //   }
    // },
    closePassDiolog() {
      this.passFrom.password = ''
      this.passFrom.nickname = ''
      this.passFrom.description = ''
      this.passChangeDialog = false
    },
    submitInfo(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (
            this.passFrom.password === '' &&
            this.passFrom.nickname === '' &&
            this.passFrom.description === ''
          ) {
            this.$message.warning(
              '请输入要修改的信息！'
            )
          } else {
            const { name } = JSON.parse(
              window.localStorage.getItem(
                'userInfo'
              ) || {}
            )
            if (name) {
              this.passFrom.name = name
            }
            let {
              password,
              // eslint-disable-next-line prefer-const
              nickname,
              // eslint-disable-next-line prefer-const
              description
            } = this.passFrom
            password = password ? md5(
              this.passFrom.password
            ) : ''
            UserDataChange({
              nickname,
              name,
              description,
              password
            }).then(res => {
              if (res.code === 200) {
                this.$message.success(
                  '修改成功！'
                )
                this.closePassDiolog()
              } else {
                this.$message.warning(
                  '修改失败！'
                )
              }
            })
          }
        }
      })
    },
    passChange() {
      this.passChangeDialog = true
    },
    editIsChange() {
      this.isEdit = !this.isEdit
      // this.inline = !this.isEdit
      const zhongwenBox = this.$refs.zhongwenBox
      const resizeBox1 = this.$refs.resize1
      if (!this.isEdit) {
        zhongwenBox.style.height = '100%'
        resizeBox1.style.display = 'none'
      } else {
        zhongwenBox.style.height = '50%'
      }
      this.inline = false
      this.editNum += 1000
    },
    restoreSubmit(item) {
      this.$confirm('确定还原此版本吗?')
        .then(() => {
          const data = {
            path: this.filePath,
            userid: item.userid,
            langtype: 2,
            contents: this.contentToArr()
          }
          const cb = () => {
            this.historyNum = 0
            this.drawerHistory = false
            this.$message.success('还原成功！')
          }
          this.submitEdit(data, cb)
        })
        .catch(() => {})
    },
    historyBoxClose(done) {
      // 历史版本弹框关闭之前
      this.historyNum = 0
      done()
    },
    restore(item, index) {
      // 点击历史版本
      this.historyNum = index
      // this.$confirm('确定还原此版本吗?').then(() => {
      const data = {
        path: this.filePath,
        langtype: 2,
        userid: item.userid,
        versionid: item.versionid
      }
      getHistoryZWContent(data).then(res => {
        if (res.data?.contents) {
          this.historyZWContent = ''
          res.data.contents.forEach(i => {
            this.historyZWContent += `<p>  ${
              i.content !== '' ? i.content : ''
            } </p>`
          })
        }
      })
      // this.getZangContent(data).then(res => {
      //   if (res) {
      //     // this.historyNum = 0
      //     // this.drawerHistory = false
      //     // this.$message.success('还原成功！')
      //   }
      // }).catch(err => {
      //   window.console.log(err)
      // })
      // }).catch(() => { })
    },
    lookHistory() {
      // 查看历史版本弹框
      this.drawerHistory = true
      const data = {
        path: this.filePath,
        langtype: 2,
        userid: this.userInfo.userid
      }
      getverlist(data).then(res => {
        if (
          res.code === 200 &&
          res.data?.versionlist
        ) {
          this.editHistoryList =
            res.data.versionlist
        }
      })
    },
    loginOut() {
      // 退出登录
      REMOVE_TOKEN()
      this.$router.push('/login')
    },
    nodeClick(data, node) {
      if (
        node.level === 2 &&
        node.childNodes?.length > 0 &&
        node.expanded
      ) {
        this.getAllData(data)
      }
    },
    clickToContent(node, data) {
      const { id } = data
      if (id) {
        // 点击段名去正文
        const zsId = document.getElementById(
          `zw${id}`
        )
        if (zsId) {
          const contentBox = this.$refs
            .zhongwenBox
          const zsTop = zsId.offsetTop - 25
          contentBox.scrollTo(0, zsTop)
        }
        const ifr = document.querySelector(
          'iframe'
        )
        const zangwenBox =
          ifr?.contentDocument.getElementById(
            'tinymce'
          ) || document.getElementById('zwEdit')
        if (zangwenBox?.children?.length > 1) {
          for (
            let i = 0;
            i < zangwenBox.children.length;
            i++
          ) {
            const item = zangwenBox.children[i]
            let itemstr = item.innerText.match(
              /\（([^\)]+)\）/
            )
            let datastr = data.name.match(
              /\（([^\)]+)\）/
            )
            if (itemstr) {
              itemstr = itemstr[0]
            }
            if (datastr) {
              datastr = datastr[0]
            }
            if (
              item.innerText === data.name ||
              (itemstr !== null &&
                itemstr === datastr)
            ) {
              if (ifr) {
                ifr.contentWindow.scroll(
                  0,
                  item.offsetTop
                )
              } else {
                setTimeout(() => {
                  zangwenBox.scrollTo(
                    0,
                    item.offsetTop
                  )
                }, 100)
              }
              break
            }
          }
        }
      }
    },
    submit() {
      // 提交编辑
      this.$confirm(
        '是否提交本次编辑的内容! ',
        '提示'
      )
        .then(() => {
          const {
            remark,
            translated
          } = this.submitForm
          const data = {
            path: this.filePath,
            langtype: 2,
            userid: this.userInfo.userid,
            contents: this.contentToArr(),
            remark,
            translated: Number(translated)
          }
          this.submitEdit(data, () => {
            this.$message.success('提交成功! ')
          })
        })
        .catch(() => {})
    },
    contentToArr() {
      const arr = []
      this.zwContent
        .split('\n')
        .forEach((i, x) => {
          arr.push({
            paragraphindex: x + 1,
            content: i
          })
        })
      return arr
    },
    submitEdit(data, callback) {
      // 发送提交编辑
      submitContent(data)
        .then(res => {
          if (res.code === 200) {
            this.dialogSubmit = false
            this.submitForm = {
              remark: '', // 备注
              translated: '0' // 是否完成翻译
            }
            callback && callback()
          } else {
            this.$message.error(res.message)
            this.msg = '网络异常，提交失败！'
          }
        })
        .catch(() => {
          this.msg = '网络异常，提交失败！'
        })
    },
    boxScrollChange(id) {
      // 滚动条联动
      if (!this.isScroll) return
      const box1 = this.$refs.zhongwenBox
      // const box2 = this.$refs.zangwenBox
      const box2 = document.getElementById(
        'zwEdit'
      )
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        // if (id === 'zangwenBox') {
        // box1.scrollTop = box2.scrollTop
        // } else if (id === 'zhongwenBox') {
        box2.scrollTop = box1.scrollTop
        // }
      }, 300)
    },
    colorred(v) {
      // 搜索关键字高亮
      const reg = new RegExp(this.keyword, 'g')
      return v.replace(
        reg,
        `<span class="red">${this.keyword}</span>`
      )
    },
    searchZS() {
      this.drawer = true
      if (this.keyword === '') return
      // 搜索注释
      const data = {
        key: this.keyword,
        langtype: 1
      }
      getSearch(data).then(res => {
        if (res.data?.keys) {
          this.searchList = res.data.keys
        }
      })
    },
    searchClick() {
      // 点击搜索按钮
      this.searchZS()
      this.drawer = true
    },
    selectChange(e) {
      // 右键点击中文内容的时候
      const selectKey = window
        .getSelection()
        .toString()
      this.keyword = selectKey || ''
      const btn = this.$refs.searchBtn
      btn.style.top = e.clientY + 'px'
      btn.style.left = e.clientX + 'px'
      this.searchBtnIsShow = true
    },
    zhitemClick(i, e) {
      // 点击中文注释, 跳到对应注释位置
      const item = e.target
      if (
        item.tagName === 'I' &&
        item.id === `zj${item.innerText}`
      ) {
        const zsId = document.getElementById(
          `tibetan${item.innerText}`
        )
        if (zsId) {
          document
            .querySelectorAll('.bg')
            .forEach(i => {
              i.classList.remove('bg')
            })
          zsId.classList.add('bg')
          const rightBox = document.getElementsByClassName(
            'right'
          )[0]
          const zsTop =
            zsId.offsetTop - rightBox.offsetTop
          rightBox.scrollTo(0, zsTop)
        }
      }
    },
    zhcon(v) {
      // 格式化注解
      if (!v) return ''
      const reg = new RegExp('\\[(.+?)\\]', 'g')
      v = v.replace(
        reg,
        `<i class="jz" id="zj$1">$1</i>`
      )
      return v
    },
    resetContent() {
      // 清空内容
      this.zhContent = []
      this.zwContent = ''
      this.zjContent = []
    },
    getZangContent(data) {
      // 请求藏文经文
      return getContent(data).then(res => {
        if (res.code === 200) {
          this.userStatus.write =
            res.data.write || 0
          this.disabled = res.data.write === 0
          this.userStatus.translated =
            res.data.translated || 0
          if (res.data.contents) {
            this.zwContent = ''
            let str = ''
            res.data.contents.forEach(i => {
              str += `<p>  ${
                i.content !== '' ? i.content : ''
              }</p> \n`
              // this.zwContent += i.content !== '' ? `<p>${i.content}</p>\n` : ''
            })
            this.zwContent = str
            this.subTimer = 0.1
            this.oldContent = this.zwContent
            return Promise.resolve(true)
          }
        } else {
          return Promise.reject(res.message)
        }
      })
    },
    getAllData(data, cb) {
      this.filePath = data.path
      this.resetContent()
      const get1 = getContent({
        path: data.path,
        langtype: 1
      }).then(res => {
        // 请求中文经文
        if (res.code === 200) {
          this.zhContent =
            res.data.contents || []
          return Promise.resolve(true)
        }
      })
      const get2 = this.getZangContent({
        path: data.path,
        langtype: 2
      })
      const get3 = getContent({
        path: data.path,
        langtype: 3
      }).then(res => {
        // 请求中文经文注解
        if (res.code === 200) {
          this.zjContent =
            res.data.footnotes || []
          return Promise.resolve(true)
        }
      })
      Promise.all([get1, get2, get3]).then(
        ([r1, r2, r3]) => {
          if (cb && ((r1 && r3) || r2)) {
            window.console.log('')
          }
        }
      )
    },

    // 点击箭头获取子目录
    loadNode(node, resolve) {
      this.subTimer = 0.1
      this.msg = ''
      if (node.level > 0 || node.level === 1) {
        if (node.data.path.indexOf('docx') > -1) {
          this.getAllData(node.data)
        }
        this.getUrlList(node.data.path, false)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            // this.$message.warning("请求出错");
            console.log(err)
            resolve()
          })
        // }
      }
    },
    // 格式化返回的数据格式
    formatting(list) {
      let arr = []
      arr = list.map((i, x) => {
        const item = i
        item.label = i.name
        item.leaf = !i.children
        item.id = i.lastmodify
          ? i.lastmodify + x
          : i.id
        if (i.name.indexOf('docx') > -1) {
          item.leaf = false
        }
        return item
      })
      return arr
    },
    async getUrlList(url, isclick) {
      // 获取目录列表
      let arr = []
      const res = await getUrl({ dir: url }).then(
        resData => {
          if (
            resData.code === 200 &&
            resData.data.dir
          ) {
            arr = this.formatting(
              resData.data.dir
            )
            if (isclick) {
              this.urlList = arr
            }
            return arr
          }
        }
      )
      return this.formatting(res)
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeBoxChange)
  }
}
